var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feedback-star"},[_c('StarRating',{staticClass:"feedback-star__rating",attrs:{"rating":5-_vm.stars}}),(_vm.skeleton)?_c('div',{staticClass:"feedback-star__line skeleton"}):_c('div',{staticClass:"feedback-star__line"},[_c('div',{staticClass:"feedback-star__progress",style:({width: _vm.progress + '%'})})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }